export const ITONICS_URIS = ['2BLxe0fqsVPsQbzc', 'QHsINjpTgAI2LlHW', 'fPOxyfOzcnp7WUvv']; // itonics space uris of test, stage and live to check if the type, field and controls are the vanilla/default or not
